// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Flex, Stack } from '@mantine/core';

type Props = {
  mainPanel: ReactNode;
  detailPanel: ReactNode;
};

/**
 * Presents a two-panel layout
 * At the large breakpoint, the main content takes up about 60% of a large screen and the detail content takes up 40%.
 *
 * For larger sizes, the main content scales while the detail content remains fixed.
 *
 * For smaller sizes, the content is presented in a single column where the main content takes up at least 60% of the
 * screen height
 **/
export const TwoPanelLayout = ({ mainPanel, detailPanel }: Props) => (
  <Flex flex={1} h="100%" mih={0} miw={0} direction={{ base: 'column', lg: 'row' }} gap="sm">
    <Stack gap={0} flex={1} mih="60dvh" style={{ overflow: 'hidden' }}>
      {mainPanel}
    </Stack>
    <Stack
      gap={0}
      flex={{ base: 1, lg: 0 }}
      miw={{ lg: 'calc(var(--mantine-breakpoint-lg) * 0.4)' }}
      style={{ overflow: 'hidden' }}
    >
      {detailPanel}
    </Stack>
  </Flex>
);
